<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="咨询问题" prop="title">
        <el-input v-model="form.title" placeholder="请输入" maxlength="50" show-word-limit />
      </el-form-item>
      <el-form-item label="回答类型" prop="type">
        <el-select v-model="form.type" placeholder="请选择" clearable size="small">
          <el-option label="文字" :value="10"></el-option>
          <el-option label="产品" :value="20"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文字" prop="content" v-if="form.type === 10">
        <el-input v-model="form.content" placeholder="请输入需要回答的内容" maxlength="50" show-word-limit />
      </el-form-item>
      <el-form-item label="产品" prop="sysGoodsList" v-if="form.type === 20">
        <el-select v-model="form.sysGoodsList" placeholder="请选择" multiple clearable filterable>
          <el-option v-for="it in productOptions" :key="it.id" :label="it.name" :value="it.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="isEnable">
        <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch> {{form.isEnable?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysGoodsApi from '@/api/goods/sysGoods'
import custServiceGuessConsultApi from '@/api/customer/custServiceGuessConsult'
function initFormBean() {
  const formBean = {
    title: null,
    type: null,
    content: null,
    sysGoodsList: [],
    isEnable: false,
  }
  return formBean
}

export default {
  data() {
    return {
      productOptions: [],
      form: initFormBean(),
      formVisible: false,
      formRules: {
        title: [{ required: true, message: '请输入咨询问题', trigger: 'blur' }],
        type: [{ required: true, message: '请选择回答类型', trigger: 'change' }],
        content: [{ required: true, message: '请输入需要回答的内容', trigger: 'blur' }],
        sysGoodsList: [{ required: true, message: '请选择产品', trigger: 'change' }],
        isEnable: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {
    this.getProductOptions()
  },
  methods: {
    getProductOptions() {
      sysGoodsApi.productOptions({}).then((res) => {
        let { list } = res.data;
        this.productOptions = list
      })
    },
    resetForm() {
      this.form = initFormBean()
    },
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.$set(this.form, 'sysGoodsList', row.sysGoodsList.map(obj => obj.id))
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            custServiceGuessConsultApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            custServiceGuessConsultApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(data) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    handleDeleteItem(index) {
      this.form.content.splice(index, 1)
    },
    handleAddItem() {
      this.form.content.push({ content: '', infoLibraryId: 0 })
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}

.ipt-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  padding-right: 20px;
  i {
    font-size: 16px;
    cursor: pointer;
  }
}
.input-box:last-child {
  margin-bottom: 0;
}

::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
</style>
